<template>
  <div class="home">
  
    <div justify="center" align="center">
      <h1>{{ groupeFromUser.nom_groupe }}</h1>
      <h1>{{ groupeFromUser.ll_region }}  {{ groupeFromUser.ll_district }}</h1>
      <h2>
        {{ groupeFromUser.ll_commune }}  {{ groupeFromUser.ll_fokontany }}
      </h2>

      <h3>{{ groupeFromUser.village }}</h3>
       <h3>{{ groupeFromUser.nom_responsable }}</h3>
    </div>
    <div v-if="isGroupeActive">
      <div v-if="isUnlocked">
        Débloqué Bienvenue
        <Navigation :elements="GroupeNavigation" />
      </div>
      <div v-else>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card class="elevation-12 pb-6">
                <v-toolbar color="primary" class="text-center" dark flat>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>
                    Entrez les 3 codes por dévérouiller
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text class="px-10">
                  <v-form ref="formUnlock">
                    <v-text-field
                      v-model="pin1"
                      :label="'Code 1'"
                      prepend-icon="lock"
                      :rules="inputRules"
                      required
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-model="pin2"
                      :label="'Code 2'"
                      prepend-icon="lock"
                      :rules="inputRules"
                      required
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-model="pin3"
                      :label="'Code 2'"
                      prepend-icon="lock"
                      :rules="inputRules"
                      required
                      type="number"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions class="px-10">
                  <v-spacer />
                  <v-btn @click="unlock" color="primary">
                    Déverrouiller l'application
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <div justify="center" align="center" v-else>
      <h4>
        Le groupe n'est pas actif, contactez un superviseur pour l'activer
      </h4>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import getAge from "get-age";
import sha256 from "crypto-js/sha256";
export default {
  data: () => ({
    isGroupeActive: false,
    isUnlocked: false,
    memberToInsert: "",
    transactions: [],
    inputRules: [
      (v) => !!v || "requis",
      (v) => (v && v.length >= 3) || "Au moins trois caractères",
    ],
    menudateDeNaissance: false,

    sexes: ["Masculin", "Féminin"],
    nom_membre: "",
    dateDeNaissance: "",
    sexe_membre: "",

    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },

    membres: [],
    headersMembre: [
      {
        text: "nom",
        align: "start",

        value: "nom",
      },
      { text: "Sexe", value: "sexe_membre" },
      { text: "Age", value: "age" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    reunions: [],
    headersReunion: [
      {
        text: "Date de la Réunion",
        align: "start",
        sortable: false,
        value: "nom",
      },
    ],
    sac1: "",
    sac2: "",
    sac3: "",
    pin1: "",
    pin2: "",
    pin3: "",
    dialog: false,
    id_groupe: null,
    groupe: { localisation: {} },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    ...mapState({
      groupeFromUser: (state) => state.Auth.user,
      GroupeNavigation: (state) => state.Navigation.GroupeNavigation,
    }),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  beforeMount() {
    this.getGroupeData();
    this.getMembres();
    this.getReunions();
  },

  mounted() {},
  methods: {
    unlock() {
      if (this.$refs.formUnlock.validate()) {
        const groupeCode = this.groupe.unlock_code;
        const codeEntered = sha256(
          this.pin1 + this.pin2 + this.pin3
        ).toString();
        if (groupeCode === codeEntered) {
          this.isUnlocked = true;
        } else {
          this.isUnlocked = false;
        }
      }
    },
    age(date) {
      const age = getAge(date);
      return age;
    },
    getGroupeData() {
      //console.log(this.$firebase.auth().currentUser.uid);
      let self = this;
      let groupeRef = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(this.$firebase.auth().currentUser.uid);
      let getDoc = groupeRef
        .get()
        .then((doc) => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            self.groupe = doc.data();
            self.isGroupeActive = self.groupe.active;
          }
        })
        .catch((err) => {
          console.log("Error getting  ", err);
        });
    },
    getMembres() {
      //console.log(this.$firebase.auth().currentUser.uid);
      let self = this;
      self.$firebase
        .firestore()
        .collection("membres")
        .where(
          "groupes",
          "array-contains",
          this.$firebase.auth().currentUser.uid
        )
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var membre = doc.data();
            membre.id = doc.id;
            self.membres.push(membre);
          });
        });
    },
    getReunions() {
      //console.log(this.$firebase.auth().currentUser.uid);
      let self = this;
      self.$firebase
        .firestore()
        .collection("reunions")
        .where("id_groupe", "==", this.$firebase.auth().currentUser.uid)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var reunion = doc.data();
            reunion.id = doc.id;
            self.reunions.push(reunion);
          });
        });
    },
    createMembre() {
      let self = this;
      const FieldValue = this.$firebase.firestore.FieldValue;
      if (this.$refs.forNewMembre.validate()) {
        const dataTosendToMembres = {
          nom: this.nom_membre,
          dateDeNaissance: this.dateDeNaissance,
          sexe_membre: this.sexe_membre,
          groupes: [this.$firebase.auth().currentUser.uid],
          dateInsert: FieldValue.serverTimestamp(),
        };

        //insert dans membres
        let addMembre = this.$firebase
          .firestore()
          .collection("membres")
          .add(dataTosendToMembres)
          .then((ref) => {
            dataTosendToMembres.id = ref.id;
            // console.log(dataTosendToMembres);
            self.membres.push(dataTosendToMembres);
          });

        //update dans Groupe
        //preparer data to send
        const dataTosendToGroupe = {
          membres: this.membres,
        };
        let groupeRef = this.$firebase
          .firestore()
          .collection("groupes")
          .doc(this.$firebase.auth().currentUser.uid);
        let updateGroupe = groupeRef.update(dataTosendToGroupe);
        this.close();
      }
    },
    createReunion() {
      //insert dans Groupe
      //insert dans reunions
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.$refs.forNewMembre.reset();
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>
